import {Mic} from 'lucide-react';

const EmptyLabState = () => (
    <div className="flex flex-col items-center justify-center h-full text-center">
        <div
            className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-4">
            <Mic className="w-10 h-10 text-accent-secondary"/>
        </div>
        <p className="text-zinc-400 text-lg mb-2">No transcriptions yet</p>
        <p className="text-zinc-500 text-sm max-w-md">
            Start recording and speak to see your transcriptions appear here in real-time
        </p>
    </div>
)

export default EmptyLabState